import React from "react";
import PropTypes from "prop-types";

function Spec({spec, onChange, collapsed}) {
    const [copied, setCopied] = React.useState(null);
    const [editing, setEditing] = React.useState(false);
    const [newVal, setNewVal] = React.useState(spec);
    React.useEffect(
        () => setNewVal(spec),
        [spec],
    );
    React.useEffect(
        () => {
            // eslint-disable-next-line no-settimeout
            const id = setTimeout(() => setCopied(null), 3000);
            return () => clearTimeout(id);
        },
        [copied],
    );
    if (editing) {
        return <textarea
            value={newVal}
            onChange={e => setNewVal(e.target.value)}
            onBlur={() => {
                onChange(newVal);
                setEditing(false);
            }}
            rows={4}
            style={{width: "100%"}}
            autoFocus
        />;
    }
    return <React.Fragment>
        <code style={{position: "relative"}}>
            {onChange && <button
                onClick={() => setEditing(true)}
                title={"Edit raw spec"}
                style={{position: "absolute", top: 0, right: 0}}
            >
                ✐
            </button>}
            {collapsed
                ? spec.replace(/([[,(|:])/g, "$1\u200B")
                : spec.replace(/([[,])/g, "$1 ")
                    .split(" ")
                    .map((it, i) =>
                        <div
                            key={i}
                            className={i === 0 ? null : "indent"}
                        >
                            {it.replace(/([(])/g, "$1 ")
                                .split(" ")
                                .map((it, i) =>
                                    <div
                                        key={i}
                                        className={i === 0 ? null : "indent"}
                                    >
                                        {it}
                                    </div>)}
                        </div>)}
        </code>
        {(!onChange || !editing) && <React.Fragment>
            <button
                onClick={() => navigator.clipboard
                    .writeText(spec)
                    .then(() => setCopied(Date.now()))}
            >
                raw
            </button>
            <button
                onClick={() => navigator.clipboard
                    .writeText(encodeURIComponent(spec))
                    .then(() => setCopied(Date.now()))}
            >
                encoded
            </button>
            {copied && <span className={"alert alert-info"}>
                Copied!
            </span>}
        </React.Fragment>}
    </React.Fragment>;
}

Spec.propTypes = {
    spec: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    collapsed: PropTypes.bool,
};

export default Spec;



// WEBPACK FOOTER //
// ./app/lib/reauth/Spec.js